export const dotenv = {
  API_BASE_URL: 'https://preprod-api.roofvox.ai',
  WS_URL: 'https://preprod-gateway.roofvox.ai',
  FRONTEND_URL: 'https://preprod-app.roofvox.ai',
  GOOGLE_CLIENT_ID:
    '503434308086-f4cnl12euc8m1gff1ddgo5rv27khikvh.apps.googleusercontent.com',
  VITE_FIREBASE_API_KEY: 'AIzaSyAnkKBdDZ_32d5-yErtInJFVAPmAW8oxOg',
  VITE_FIREBASE_AUTH_DOMAIN: 'smart-contractor-471108.firebaseapp.com',
  VITE_FIREBASE_PROJECT_ID: 'smart-contractor-471108',
  VITE_FIREBASE_STORAGE_BUCKET: 'smart-contractor-471108.firebasestorage.app',
  VITE_FIREBASE_MESSAGING_SENDER_ID: '1090586343889',
  VITE_FIREBASE_APP_ID: '1:1090586343889:web:3a5ed360e7581d470708f0',
  VITE_FIREBASE_VAPID_KEY:
    'BKpmXoKzlEn8ExKSwPhXUcx-ehPrnHJ-aggy_DVB6vWlRF4eSwwZZo2OVAHb8wfzeeUjRkV7JPathNzYp0Pg-0o'
};
